var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rules"},[_c('van-popup',{model:{value:(_vm.showPop),callback:function ($$v) {_vm.showPop=$$v},expression:"showPop"}},[_c('img',{attrs:{"src":"https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/questionlottery/rulebg.png","alt":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }